// Taken from https://github.com/TheWWWorm/proxy-mock (MIT license)
//
// Another more-heavy approach would have been https://github.com/CreativeTechGuy/recursive-proxy-mock

"use strict";

/**
 * @param {Object} [specifics={}] specifics - allows avoid generating specific keys, will use keys from provided object instead
 * @param {String} [name='proxyMock'] name - useful in testing scenarios, when you want to see if spy failed or not
 * @param {Function} spyWrap - spy wrapper, can be used for auto-spying on the proxy. Should accept (name, function) for spying
 */
export const getProxyMock = (
  specifics: Record<string, any> = {},
  name: string = "proxyMock",
  wrap?: (name: string, fn: () => void) => any,
) => {
  function _target(): void {
    getProxyMock();
  }

  const target = wrap ? wrap(name, _target) : _target;

  target[Symbol.toPrimitive] = (hint: string): string | number => {
    if (hint === "string") {
      return "proxyString";
    } else if (hint === "number") {
      return 42;
    }
    return "1337";
  };
  target[Symbol.iterator] = function* () {
    yield getProxyMock({}, `${name}.Symbol(Symbol.iterator)`, wrap);
  };

  return new Proxy(target, {
    get(obj: Record<string | symbol, any>, key: string | symbol): any {
      const keyStr = key.toString();
      if (specifics.hasOwnProperty(keyStr)) {
        return specifics[keyStr];
      }
      if (keyStr === "Symbol(Symbol.toPrimitive)") {
        return obj[Symbol.toPrimitive];
      }
      if (keyStr === "Symbol(Symbol.iterator)") {
        return obj[Symbol.iterator];
      }
      if (!obj.hasOwnProperty(keyStr)) {
        obj[keyStr] = getProxyMock({}, `${name}.${keyStr}`, wrap);
      }
      return obj[keyStr];
    },
  });
};
